import React from "react";
import ExpertTabComponent from "./component/ExpertTabComponent";

const ExpertsPage = () => {
  return (
    <>
      <div className="pt-28 lg:pt-32 pb-10 px-[5vw] sm:px-[10vw] xl:px-[15vw] bg-yellow flex flex-col gap-4">
        <div className="flex flex-col gap-1 text-center">
          <h1 className="uppercase text-xl lg:text-2xl text-ash-500 pt-3">
            Meet our experts
          </h1>
        </div>
      </div>
      <div className="px-[5vw] sm:px-[10vw] xl:px-[15vw] py-5">
        <div>
          <p className="text-ash-500 pb-5">
            Meet the team of the most trusted real
            estate business. With proven years of experience in the real estate
            industry, Primus Agents are dedicated to providing high-quality real
            estate and project management services.
          </p>
        </div>
        {/* show the tab */}
        <ExpertTabComponent/>
      </div>
    </>
  );
};

export default ExpertsPage;
